import * as React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { v1 } from 'uuid';
import Typography from '@mui/material/Typography';
import ClassNumberAsync from '../form/ClassNumberAsync';
import Button from '@mui/material/Button';
import FirstName from '../form/FirstName';
import LastName from '../form/LastName';
import Address from '../form/Address';
import City from '../form/City';
import State from '../form/State';
import Zip from '../form/Zip';
import { config } from '_config';

const cardInfo = {
  id: v1(),
  goods: 'true',
  goodsCategory: null,
  goodsServiceDetail: null,
  clazz: null,
  descriptions: [],
};

export default function RenewalStep2({
  state,
  onChange,
  validated,
  onHandleCategoriesStillInUse,
  onHandleCategoriesNoLongerInUse,
  imageSpecimenSrc,
  allowedExtensions,
}) {
  const addNewCardInUse = (event) => {
    event.preventDefault();
    const clone = JSON.parse(JSON.stringify(cardInfo));
    clone.id = v1();
    onHandleCategoriesStillInUse(
      state.goodsAndServicesStillInUse.concat(clone)
    );
  };
  const handleChangeInUse = (event, id) => {
    onHandleCategoriesStillInUse(
      state.goodsAndServicesStillInUse.map((item) => {
        if (item.id === id) {
          if (event.target.name) {
            return { ...item, goods: event.target.value };
          } else {
            if (event.target.id.includes('goodsCategory')) {
              return { ...item, goodsCategory: event.target.value };
            } else if (event.target.id.includes('descriptions')) {
              item.descriptions[event.target.id.substring(12)] =
                event.target.value;
              return { ...item };
            }
            return { ...item, [event.target.id]: event.target.value };
          }
        } else {
          return item;
        }
      })
    );
  };
  const removeCardInUse = (event, id) => {
    onHandleCategoriesStillInUse(
      state.goodsAndServicesStillInUse.filter((item) => item.id !== id)
    );
  };
  const addNewCardNotInUse = (event) => {
    event.preventDefault();
    const clone = JSON.parse(JSON.stringify(cardInfo));
    clone.id = v1();
    onHandleCategoriesNoLongerInUse(
      state.goodsAndServicesNoLongerInUse.concat(clone)
    );
  };
  const handleChangeNotInUse = (event, id) => {
    onHandleCategoriesNoLongerInUse(
      state.goodsAndServicesNoLongerInUse.map((item) => {
        if (item.id === id) {
          if (event.target.name) {
            return { ...item, goods: event.target.value };
          } else {
            if (event.target.id.includes('goodsCategory'))
              return { ...item, goodsCategory: event.target.value };
            return { ...item, [event.target.id]: event.target.value };
          }
        } else {
          return item;
        }
      })
    );
  };
  const removeCardNotInUse = (event, id) => {
    onHandleCategoriesNoLongerInUse(
      state.goodsAndServicesNoLongerInUse.filter((item) => item.id !== id)
    );
  };

  return (
    <Form id="TrademarkForm" noValidate validated={validated}>
      <div className="question">
        <div className="polaroid">
          <p className="primary-label">Is the trademark still in use?</p>

          <Form.Check
            inline
            label="Yes, on all of the goods or services listed in the registration."
            name="inUseStatus"
            type="radio"
            id="inUseStatus1"
            value={'YES_ON_ALL'}
            checked={state.inUseStatus === 'YES_ON_ALL'}
            onChange={onChange}
          />
          <br />
          <Form.Check
            inline
            label="Yes, on some of the goods or services listed in the registration."
            name="inUseStatus"
            id="inUseStatus2"
            type="radio"
            value={'YES_ON_SOME'}
            checked={state.inUseStatus === 'YES_ON_SOME'}
            onChange={onChange}
          />
          <br />
          <Form.Check
            inline
            label="No"
            name="inUseStatus"
            id="inUseStatus3"
            type="radio"
            value={'NO'}
            checked={state.inUseStatus === 'NO'}
            onChange={onChange}
          />
        </div>
        {state.inUseStatus === 'YES_ON_SOME' ? (
          <div className="question">
            {config.skin !== 'v2-basic' && (
              <p>Goods and Services Still in Use</p>
            )}
            {config.skin === 'v2-basic' && (
              <h2>Goods and Services Still in Use</h2>
            )}
            {(state.goodsAndServicesStillInUse || []).map((item) => (
              <div className="polaroid">
                <div
                  style={{
                    marginTop: config.skin !== 'v2-basic' ? '20px' : 0,
                    marginBottom: '20px',
                  }}
                  key={item.id}
                >
                  <Typography className="primary-label">
                    Do you sell, or intend to sell, a goods or service?
                  </Typography>
                  <Form.Group className="mb-4 ownerTop" controlId={'goods'}>
                    <Form.Check
                      inline
                      label="Goods"
                      name={item.id + '_goods'}
                      type="radio"
                      value={'true'}
                      checked={item.goods === 'true'}
                      onChange={() => handleChangeInUse(event, item.id)}
                      id={item.id + `goodOrService1`}
                    />

                    <Form.Check
                      inline
                      label="Services"
                      type="radio"
                      name={item.id + '_goods'}
                      value={'false'}
                      checked={item.goods === 'false'}
                      onChange={() => handleChangeInUse(event, item.id)}
                      id={item.id + `goodOrService2`}
                    />
                  </Form.Group>
                  <ClassNumberAsync
                    controlId={item.id}
                    goods={item.goods}
                    goodsCategory={item.goodsCategory}
                    descriptions={item.descriptions}
                    validated={validated}
                    onChange={(event) => handleChangeInUse(event, item.id)}
                  />
                  {state.goodsAndServicesStillInUse.length > 1 ? (
                    <Button
                      className="addOwner"
                      variant="contained"
                      onClick={() => removeCardInUse(event, item.id)}
                    >
                      - Remove Class
                    </Button>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            ))}
            <Button
              className="addOwner"
              variant="contained"
              onClick={addNewCardInUse}
            >
              + Add Class
            </Button>
            {config.skin === 'v2-basic' && (
              <h2>Goods and Services No Longer in Use</h2>
            )}
            {config.skin !== 'v2-basic' && (
              <p style={{ marginTop: '20px' }}>
                Goods and Services No Longer in Use
              </p>
            )}
            {(state.goodsAndServicesNoLongerInUse || []).map((item) => (
              <div className="polaroid">
                <div
                  style={{
                    marginTop: config.skin !== 'v2-basic' ? '20px' : 0,
                    marginBottom: '20px',
                  }}
                  key={item.id}
                >
                  <Typography className="primary-label">
                    Do you sell, or intend to sell, a goods or service?
                  </Typography>
                  <Form.Group className="mb-4 ownerTop" controlId={'goods'}>
                    <Form.Check
                      inline
                      label="Goods"
                      name={item.id + '_goods'}
                      type="radio"
                      value={'true'}
                      checked={item.goods === 'true'}
                      onChange={() => handleChangeNotInUse(event, item.id)}
                      id={item.id + `goodOrService1`}
                    />

                    <Form.Check
                      inline
                      label="Services"
                      type="radio"
                      name={item.id + '_goods'}
                      value={'false'}
                      checked={item.goods === 'false'}
                      onChange={() => handleChangeNotInUse(event, item.id)}
                      id={item.id + `goodOrService2`}
                    />
                  </Form.Group>
                  <ClassNumberAsync
                    controlId={item.id}
                    goods={item.goods}
                    goodsCategory={item.goodsCategory}
                    descriptions={item.descriptions}
                    validated={validated}
                    onChange={(event) => handleChangeNotInUse(event, item.id)}
                  />
                  {state.goodsAndServicesNoLongerInUse.length > 1 ? (
                    <Button
                      className="addOwner"
                      variant="contained"
                      onClick={() => removeCardNotInUse(event, item.id)}
                    >
                      - Remove Class
                    </Button>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            ))}
            <Button
              className="addOwner"
              style={{ marginBottom: '20px' }}
              variant="contained"
              onClick={addNewCardNotInUse}
            >
              + Add Class
            </Button>
          </div>
        ) : (
          ''
        )}
        <div className="polaroid">
          <p className="primary-label">Is the Owner the same?</p>
          <Form.Check
            inline
            label="Yes"
            name="isNewName"
            type="radio"
            id="isNewName1"
            value={'true'}
            checked={state.isNewName === 'true'}
            onChange={onChange}
          />
          <Form.Check
            inline
            label="No"
            name="isNewName"
            id="isNewName2"
            type="radio"
            value={'false'}
            checked={state.isNewName === 'false'}
            onChange={onChange}
          />
          {state.isNewName === 'false' ? (
            <div className="two-column-form">
              <p style={{ marginTop: '1em' }}>
                Please provide the new owner's first and last name
              </p>
              <Form.Group as={Row}>
                <Col sm={6}>
                  <FirstName
                    id="newFirstName"
                    label="First Name"
                    value={state.newFirstName}
                    onChange={onChange}
                  />
                </Col>
                <Col sm={6}>
                  <LastName
                    id="newLastName"
                    label="Last Name"
                    value={state.newLastName}
                    onChange={onChange}
                  />
                </Col>
              </Form.Group>
            </div>
          ) : (
            ''
          )}
        </div>
        <div className="polaroid">
          <p className="primary-label">Is the Address the same?</p>
          <Form.Check
            inline
            label="Yes"
            name="isNewAddress"
            type="radio"
            id="isNewAddress1"
            value={'true'}
            checked={state.isNewAddress === 'true'}
            onChange={onChange}
          />
          <Form.Check
            inline
            label="No"
            name="isNewAddress"
            id="isNewAddress2"
            type="radio"
            value={'false'}
            checked={state.isNewAddress === 'false'}
            onChange={onChange}
          />
          {state.isNewAddress === 'false' ? (
            <div className="two-column-form">
              <p style={{ marginTop: '1em' }}>Please provide the new address</p>
              <Form.Group as={Row}>
                <Col sm={6}>
                  <Address
                    id="newaddress"
                    label="Address"
                    state={state}
                    onChange={onChange}
                  />
                </Col>
                <Col sm={6}>
                  <City
                    id="newcity"
                    label="City"
                    state={state}
                    onChange={onChange}
                  />
                </Col>
                <Col sm={6}>
                  <State
                    id="newstate"
                    label="State/Province/Region"
                    state={state}
                    onChange={onChange}
                  />
                </Col>
                <Col sm={6}>
                  <Zip
                    id="newzip"
                    label="Zip/Postal Code"
                    state={state}
                    onChange={onChange}
                  />
                </Col>
              </Form.Group>
            </div>
          ) : (
            ''
          )}
        </div>
        <div className="polaroid">
          <p className="primary-label">
            Please upload specimen file or provide URL
          </p>
          <label
            className="form-label col-form-label col"
            style={{
              fontSize: '10px',
              lineHeight: '18px',
              textTransform: 'uppercase',
              marginBottom: '0px',
              paddingTop: '0px',
            }}
          >
            A Specimen is a real-world example of how exactly the trademark is
            used with a good or service. Some examples of appropriate specimens
            include; tags, product packaging or advertisements for services.
          </label>
          <Form.Check
            inline
            label="File"
            name="specimen"
            type="radio"
            id="specimen1"
            value={'true'}
            checked={state.specimen === 'true'}
            onChange={onChange}
          />
          <Form.Check
            inline
            label="URL"
            name="specimen"
            id="specimen2"
            type="radio"
            value={'false'}
            checked={state.specimen === 'false'}
            onChange={onChange}
          />
          {state.specimen === 'true' ? (
            <>
              <Form.Group controlId="formSpecimenFile" className="mb-3">
                <Form.Label>Upload specimen file</Form.Label>
                <Form.Control
                  type="file"
                  required={imageSpecimenSrc ? false : true}
                  accept={allowedExtensions}
                  style={{ height: '100%' }}
                  onChange={onChange}
                  isInvalid={state.isFileInvalidSize.length > 0}
                />
                <Form.Control.Feedback type="invalid">
                  {state.isFileInvalidSize.length > 0
                    ? state.isFileInvalidSize
                    : 'Please select file'}
                </Form.Control.Feedback>
              </Form.Group>
            </>
          ) : (
            <div className="one-column-form">
              <Form.Group className="mb-3" controlId="specimenURL">
                <Form.Label column required>
                  Enter the specimen URL
                </Form.Label>
                <Form.Control
                  type="text"
                  required
                  placeholder="Enter the specimen URL"
                  onChange={onChange}
                  data-hj-allow
                  value={state.specimenURL ? state.specimenURL : ''}
                />
                <Form.Control.Feedback type="invalid">
                  Please provide a valid specimen URL
                </Form.Control.Feedback>
              </Form.Group>{' '}
            </div>
          )}
        </div>
      </div>
    </Form>
  );
}
